import debounce from '../includes/debounce' 

const mega = document.querySelector('.mega')
const triggers = Array.from(document.querySelectorAll('.main-navigation [data-mega]'))

let active = false
let current = undefined
let timeout = undefined

function hide(menu) {
    current = undefined 
    active = false

    mega.style.maxHeight = `0px`
    mega.style.transform = `translateY(-100%)`
    menu.style.maxHeight = `0px`
    menu.style.opacity  = `0`

    document.body.classList.remove('mega--active')
}

function swap(menu) {
    current.style.maxHeight = `0px`
    current.style.opacity = `0`
    current.style.pointerEvents = 'none'

    current = menu
    active = true

    const height = menu.querySelector('.container').getBoundingClientRect().height
    menu.style.maxHeight = `${height}px`
    menu.style.opacity = `1`
    menu.style.pointerEvents = 'all'
}

function show(menu) {
    current = menu
    active = true

    const height = menu.querySelector('.container').getBoundingClientRect().height

    mega.style.transform = `translateY(0)`
    mega.style.maxHeight = `999px`

    menu.style.maxHeight = `${height}px`
    menu.style.pointerEvents = 'all'
    menu.style.opacity  = `1`

    document.body.classList.add('mega--active')
}

function setup(trigger) {
    const id = trigger.dataset.mega
    const menu = mega.querySelector(`.mega-container[data-mega="${id}"]`)

    trigger.addEventListener('mouseenter', () => {
        active = true
        clearTimeout(timeout)

        if (active && current) {
            swap(menu)
        } else {
            show(menu)
        }
    })

    trigger.addEventListener('mouseleave', () => {
        active = false
        timeout = setTimeout(() => {
            if (!active) {
                hide(menu)
            }
        }, 500)
    })

    mega.addEventListener('mouseenter', () => {
        active = true
    })

    mega.addEventListener('mouseleave', () => {
        active = false
        timeout = setTimeout(() => {
            if (!active) {
                hide(menu)
            }
        }, 500)
    })
}

function init() {
    if (!mega || triggers.length < 1) return;

    triggers.forEach(setup)
}

init();
